<amp-time-series-widget
  [yAxisLabel]="yAxisLabel"
  [yAxisSoftMax]="yAxisSoftMax"
  [yAxisMax]="yAxisMax"
  [yAxisTickInterval]="yAxisTickInterval"
  [data]="data$ | async"
  [dataUnit]="dataUnit"
  [precision]="precision"
>
</amp-time-series-widget>
